import type { IconProps } from '~components/internal/Icon'

export interface PersonalizationVariable {
  key: string
  label: string
  icon?: IconProps['name']
  group?: string
  section?: string
}

export { detectVariables } from './useVariableDetection'
export { default as VariableInsertButton } from './VariableInsertButton'

export const VARIABLE_INSERT_TOOLTIP =
  'Use variables to personalize each message with contact details'
